<template>
  <v-alert class="alert" v-if="notification" :value="true" :type="notification.type">
    <div
      v-for="(item, index) in notification.message"
      :key="index"
    >
      <div class="alert-text" v-html="item"/>
    </div>
  </v-alert>
</template>
<script>
  export default {
    name: 'notification',
    computed: {
      notification () {
        return this.$store.getters.getNotification
      }
    }
  }
</script>
<style>
  .alert {
    position: fixed!important;
    top:0;
    right: 0!important;
    width: 100%;
    max-width: 500px;
    z-index: 5;
  }
</style>
